import * as React from "react";
const SvgFiRrMugAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mug-alt_svg__a)">
      <path
        fill="#062147"
        d="M19 23a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h17a1 1 0 0 1 1 1m5-15c0 2.774-2.185 6-5 6h-1.612l-.3 1.821A4.984 4.984 0 0 1 12.152 20h-5.3a4.984 4.984 0 0 1-4.932-4.179L.056 4.657A4 4 0 0 1 4 0h11a3.97 3.97 0 0 1 3.983 4H19c3.131 0 5 1.5 5 4m-7.028-3.671A2 2 0 0 0 15 2H4a2 2 0 0 0-1.972 2.328l1.861 11.165A2.99 2.99 0 0 0 6.848 18h5.3a2.99 2.99 0 0 0 2.959-2.507zM22 8c0-.5 0-2-3-2h-.279l-1 6H19c1.545 0 3-2.254 3-4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mug-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMugAlt;
